import React, { useCallback, useEffect, useState } from 'react';
import { $getSelection, $isRangeSelection } from 'lexical';
import { $isListNode, ListNode } from '@lexical/list';
import { BLOCKS } from '../utils/utils';
import { listTypeToListName } from '../constants/constants';
import { $getNearestNodeOfType, mergeRegister } from '@lexical/utils';
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { Select } from 'baseui/select';
import { SELECT_PROPS } from '../../../constants/constants';
const LIST_FORMAT_OPTIONS = [{
  listType: 'bullet',
  listName: 'Bulleted List'
}, {
  listType: 'check',
  listName: 'Check List'
}, {
  listType: 'number',
  listName: 'Numbered List'
}];
const ListFormatDropDown = () => {
  const [editor] = useLexicalComposerContext();
  const [listType, setListType] = useState<keyof typeof listTypeToListName>('default');
  const [isEditable, setIsEditable] = useState(() => editor.isEditable());
  const updateToolbar = useCallback(() => {
    const selection = $getSelection();
    if (!$isRangeSelection(selection)) {
      return;
    }
    const anchorNode = selection.anchor.getNode();
    const element = anchorNode.getKey() === 'root' ? anchorNode : anchorNode.getTopLevelElementOrThrow();
    const elementKey = element.getKey();
    const elementDOM = editor.getElementByKey(elementKey);
    if (elementDOM === null) {
      return;
    }
    if ($isListNode(element)) {
      const parentList = $getNearestNodeOfType<ListNode>(anchorNode, ListNode);
      const type = parentList ? parentList.getListType() : element.getListType();
      setListType((type as keyof typeof listTypeToListName));
    } else {
      setListType('default');
    }
  }, [editor]);
  useEffect(() => {
    return mergeRegister(editor.registerEditableListener(editable => {
      setIsEditable(editable);
    }), editor.registerUpdateListener(({
      editorState
    }) => {
      editorState.read(() => {
        updateToolbar();
      });
    }));
  }, [updateToolbar, editor]);
  return <Select disabled={!isEditable} {...SELECT_PROPS} options={LIST_FORMAT_OPTIONS} labelKey="listName" valueKey="listType" onChange={({
    value
  }) => {
    BLOCKS[(value[0].listType as keyof typeof listTypeToListName)]({
      editor,
      type: listType
    });
    setListType(value[0].listType);
  }} value={[{
    listType: listType,
    listName: listTypeToListName[listType]
  }]} />;
};
export default ListFormatDropDown;